<div class="section p-3">
    <dx-data-grid
    #dataGridPSRgrpUser
      id="dataGridPSRgrpUser"
      class="manage-psr-grp-grid"
      [dataSource]="manageGrpPsrUsersData"
      [allowColumnResizing]="true" 
      [columnResizingMode]="'widget'" 
      [hoverStateEnabled]="true"
      [columnAutoWidth]="true" 
      [allowColumnReordering]="true"
      [showBorders]="true"
      (onEditingStart)="onEditingStart($event)"
      (onInitNewRow)="onAddPsrUserGrp($event)"
      (onSaved)="updatePsrUsersGrp($event)"
    >
    <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-paging [pageSize]="100000" emptyPanelText=""></dxo-paging>

          <dxo-editing
            mode="form"
            [allowUpdating]="false"
            [allowAdding]="true"
            [selectTextOnEditStart]="true"
            [allowDeleting]="true"
*ngIf="!disManageUsersGrp">
          </dxo-editing>
           

          <dxi-column type="buttons" *ngIf="!locked" [width]="60">
            <dxi-button name="delete"></dxi-button>
            <dxi-button name="edit"></dxi-button>
        </dxi-column>

      <!-- <dxi-column
        dataField="existingUsers"
        caption="ADD EXISTING USER"
        [visible]="false"
        editCellTemplate="editExistingCellTemp"
        >
          
        </dxi-column> 
        <div *dxTemplate="let cellInfo of 'editExistingCellTemp'">
          <dx-select-box
           [dataSource]="existingUsers"
            [value]="cellInfo.value"
            displayExpr="fullName"
            valueExpr="id"
            (onValueChanged)="selectExistUser($event, cellInfo)"
          >
        </dx-select-box>
        </div>  -->

        <dxi-column 
        dataField="userId" 
        caption="ADD EXISTING USER" 
        [visible]="false" 
        editCellTemplate="changeExisting"
        >
          <dxo-lookup 
          [dataSource]="existingUserList" 
          displayExpr="fullName" 
          valueExpr="mpgpsrUserId"
          >
          </dxo-lookup>
        </dxi-column>

        <div *dxTemplate="let cellInfo of 'changeExisting'">
          <dx-select-box
          [disabled]=showSelect
          [dataSource]="existingUserList" 
          displayExpr="fullName" 
          valueExpr="mpgpsrUserId"
            [value]="cellInfo.value"
            (onValueChanged)="selectExistingUser($event, cellInfo)"
          >
        </dx-select-box>
        </div> 
        
       

        <dxi-column dataField="firstName" caption="FIRST NAME" [allowEditing]=false >
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>

       
        <dxi-column dataField="speId" caption="SPE ID" [allowEditing]=allowEditing >
          <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule
          type="custom"
          [message]="customIDMsg"
          [validationCallback]="customIDValidation"
        ></dxi-validation-rule>
        </dxi-column>
       
        
        <!-- <dxi-column 
        dataField="psrGroupName" 
        [groupIndex]="0"
        caption="PSR GROUP NAME"
        editCellTemplate="changeGroup"
        [allowSorting]="false">

        </dxi-column>
        <div *dxTemplate="let cellInfo of 'changeGroup'">
          <dx-select-box
           [dataSource]="groupNameData"
            [value]="cellInfo.value"
            displayExpr="name"
            valueExpr="id"
            (onValueChanged)="selectGroupName($event, cellInfo)"
          >
        </dx-select-box>
        </div>  -->

        

     
      <dxi-column dataField="lastName" caption="LAST NAME" [allowEditing]=false >
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>

      <dxi-column 
      caption="PSR GROUP NAME" 
      dataField="psrGroupId" 
      [groupIndex]="0"
      editCellTemplate="changeGroup"
      >
        <dxo-lookup 
        [dataSource]="psrGroups" 
        displayExpr="psrGroupName" 
        valueExpr="psrGroupId">
        </dxo-lookup>
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxi-validation-rule
        type="custom"
        message="User is already associated with this selected group."
        [validationCallback]="customGroupValidation"
      ></dxi-validation-rule>
      </dxi-column>

      <div *dxTemplate="let cellInfo of 'changeGroup'">
        <dx-select-box
        [disabled]=showSelect
        [dataSource]="psrGroups" 
        displayExpr="psrGroupName" 
        valueExpr="psrGroupId"
          [value]="cellInfo.value"
          (onValueChanged)="selectGroupName($event, cellInfo)"
        >
      </dx-select-box>
      
      </div> 
     
      <dxi-column dataField="email" caption="EMAIL" [allowEditing]=false>
        <dxi-validation-rule type="required"></dxi-validation-rule>
         <dxi-validation-rule
         *ngIf="!isrowEdit"
        type="custom"
        message="Email is associated with an existing user. Please use the 'Add Existing User' field."
        [validationCallback]="customValidation"
      ></dxi-validation-rule>
      <dxi-validation-rule
      *ngIf="isrowEdit"
        type="custom"
        message="Email is associated with an existing user. Please use the 'Add Existing User' field."
        [validationCallback]="customValidation"
      ></dxi-validation-rule>
      </dxi-column>
      <!-- <dxi-column dataField="groupId" 
          dataType="string" 
          caption="PSR Group"  
          [allowEditing]="true"   
          editCellTemplate="changeGroup">
            <dxo-lookup 
              [dataSource]="groupNameData" 
              valueExpr="roleId" 
              displayExpr="roleName">
            </dxo-lookup> 
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-column>

        <div *dxTemplate="let cellInfo of 'changeGroup'">
          <dx-select-box
           [dataSource]="groupNameData"
            [value]="cellInfo.value"
            displayExpr="groupName"
            valueExpr="groupId"
            (onValueChanged)="updateGroupName($event, cellInfo)"
          >
        </dx-select-box>
        </div> -->
      <!-- <dxo-search-panel [visible]="true"></dxo-search-panel> -->
      <!-- <dxo-paging [pageSize]="10"></dxo-paging> -->
      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
    </dx-data-grid>
    <!-- <div class="options">
      <div class="caption">Options</div>
      <div class="option">
        <dx-check-box
          id="autoExpand"
          [(value)]="expand.autoExpandAll"
          text="Expand All Groups" 
        >
        </dx-check-box>
      </div>
    </div> -->
    </div>
    <app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>